export enum Tables {
  EVENT_SETTINGS = 'eventSettings',
  EVENT_INCIDENTS_QUEUE = 'eventIncidentsQueue',
  INCIDENTS_REQUIRE_POINTING_POSITION = 'incidentsRequirePointingPosition',
  ASSIGN_PLAYER_ON_PITCH = 'assignPlayerOnPitch',
  ASSIGN_INCIDENT_ON_PITCH = 'assignIncidentOnPitch',
  PLAYER_SECONDARY_POSITION = 'playerSecondaryPosition',
}

/**
 * Dexie stores - mapping of each table to it's primary key definition and indexes.
 */
export const stores: Record<Tables, string> = {
  eventSettings: 'eventId',
  eventIncidentsQueue: 'eventId',
  incidentsRequirePointingPosition: 'eventId',
  assignPlayerOnPitch: 'eventId',
  assignIncidentOnPitch: 'eventId',
  playerSecondaryPosition: '[eventId+participantId], eventId',
}
